import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../util/apiClient";
import Onglet from "./Onglet";
import ListeSouscription from "./Souscription";
import { 
  setAnneesScolaires, 
  setAnneesScolairesSouscription, 
  setDataListeSouscriptionsFocus, 
  setEnseignants, 
  setEtabs, 
  setEtabsAppelNote, 
  setFetchingEnseignants, setFetchingStudents, 
  setListeSouscriptionsFocus, 
  setSouscripteur, setStudents, setTest } from "../store/focusEcoleSlice";
import { IReduxState } from "../store";
import CommonLoading from "../components/Common/CommonLoading";
import _ from "lodash";
import Enseignant from "./Enseignant";
import CreationCompteParental from "./CreationCompteParental";
import { anneescolaire } from "../util/constant";
import EtabsSouscritFocusEcole from "./EtabsSouscritFocusEcole";

export interface IPayloadCreateCompteParentalEtab {
  codeEtab: string;
  anneeScolaire: string;
}



const ApplisMobile = () => {


  const dispatch = useDispatch();
  //hooks
  const { fetchingStudents, fetchingEnseignants, students, enseignants, etabs } = useSelector((state: IReduxState) => state.focusEcole);
  const [active, setActive] = useState(1)



  const renderContent = () => {
    if (active === 1) {
      return (<EtabsSouscritFocusEcole />)
    } else if (active === 2) {
      return (fetchingEnseignants ? <CommonLoading /> : <Enseignant />)
    }
    else if (active === 3) {
      return (<CreationCompteParental />)
    }
    else if (active === 4) {
      return (fetchingStudents ? <CommonLoading /> : <ListeSouscription />)
    }
  }

  const getStudents = async () => {
    try {
      dispatch(setFetchingStudents(true))
      const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, `/tablesystem/getStudents/${anneescolaire}`);
      if (res.status === 1) {
        // const etabsDistinct = _.uniqBy(res.data, 'codeEtab');
        // dispatch(setEtabs(etabsDistinct))
        dispatch(setStudents(res.data))
      } else {
        console.log("getStudents status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:45 ~ getStudents ~ error:", error)
    } finally {
      dispatch(setFetchingStudents(false))
    }
  };

  const getEtablissemnts = async () => {
    try {
      // dispatch(setFetchingStudents(true))
      const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, `/tablesystem/etabseligibles/${anneescolaire}`);
      if (res.status === 1) {
        const anScolDistinct = _.uniqBy(res.data, 'anScol');
        console.log("🚀 ~ getEtablissemnts ~ res.data:", res.data)
        dispatch(setAnneesScolairesSouscription(anScolDistinct))
        dispatch(setEtabs(res.data))
      } else {
        console.log("getTuteurs status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:45 ~ getTuteurs ~ error:", error)
    } finally {
      // dispatch(setFetchingStudents(false))
    }
  };

  // 
  const getDataListSouscription = async () => {
    try {
      const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, `/tablesystem/getlistetabsouscriptionfocus`);
      if (res.status === 1) {
        dispatch(setDataListeSouscriptionsFocus(res.data));
      } else {
        console.log("getTuteurs status !==1");
      }
    } catch (error) {
      console.error("🚀 ~ getDataListSouscription ~ error:", error);
    }
  };

  const getListSouscription = async () => {
    try {
      const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, `/tablesystem/getlistesouscriptionfocus`);
      if (res.status === 1) {
        dispatch(setListeSouscriptionsFocus(res.data));
      } else {
        console.log("getTuteurs status !==1");
      }
    } catch (error) {
      console.error("🚀 ~ getDataListSouscription ~ error:", error);
    }
  };


  useEffect(() => {
    getStudents();
    getEtablissemnts();
    getDataListSouscription();
    getListSouscription();
  }, []);


  return (
    <div
      style={{
        padding: 10,
        height: "80vh",
        overflow: "auto"
      }}
    >
      {/* <Grid item md={12} xs={12} sm={12}> */}
      <Onglet
        active={active}
        setActive={setActive}
      />
      {/* </Grid> */}
      {renderContent()}
    </div>
  );
};
export default ApplisMobile;
